import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { uploadService } from '../services/uploadService';
import './Header.css';

interface HeaderProps {
  title?: string;
  breadcrumbs?: { label: string; path?: string }[];
  onMenuClick?: () => void;
}

const Header: React.FC<HeaderProps> = ({ title, breadcrumbs = [], onMenuClick }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [userMenuOpen, setUserMenuOpen] = useState(false);

  const handleLogout = () => {
    setUserMenuOpen(false);
    logout();
    navigate('/login');
  };

  return (
    <header className="metronic-header" id="kt_app_header">
      <div className="header-container">
        {onMenuClick && (
          <button
            type="button"
            className="header-menu-toggle d-lg-none"
            onClick={onMenuClick}
            aria-label="Abrir menu"
          >
            <i className="bi bi-list fs-1" />
          </button>
        )}
        <div className="header-title-section">
          {title && <h1 className="header-title">{title}</h1>}
          {breadcrumbs.length > 0 && (
            <nav className="header-breadcrumb" aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Início</Link>
                </li>
                {breadcrumbs.map((b, i) => (
                  <li key={i} className="breadcrumb-item">
                    {b.path ? (
                      <Link to={b.path}>{b.label}</Link>
                    ) : (
                      <span className="active">{b.label}</span>
                    )}
                  </li>
                ))}
              </ol>
            </nav>
          )}
        </div>
        <div className="header-toolbar">
          <div className="header-user-dropdown" aria-expanded={userMenuOpen}>
            <button
              type="button"
              className="header-user-btn"
              onClick={() => setUserMenuOpen(!userMenuOpen)}
              aria-haspopup="true"
            >
              <span className="header-user-avatar">
                {user?.name?.charAt(0)?.toUpperCase() || 'U'}
              </span>
              <span className="header-user-name d-none d-md-inline">{user?.name}</span>
              <i className="bi bi-chevron-down header-user-arrow" />
            </button>
            {userMenuOpen && (
              <>
                <div
                  className="header-dropdown-backdrop"
                  onClick={() => setUserMenuOpen(false)}
                  aria-hidden="true"
                />
                <div className="header-dropdown-menu show">
                  <div className="dropdown-header">
                    {user?.logo_url ? (
                      <img
                        src={uploadService.getImageUrl(user.logo_url)}
                        alt=""
                        className="dropdown-logo me-2"
                      />
                    ) : (
                      <span className="header-user-avatar dropdown-avatar me-2">
                        {user?.name?.charAt(0)?.toUpperCase() || 'U'}
                      </span>
                    )}
                    <div>
                      <span className="dropdown-name">{user?.name}</span>
                      {user?.email && (
                        <span className="dropdown-email">{user.email}</span>
                      )}
                    </div>
                  </div>
                  <div className="dropdown-divider" />
                  <Link
                    to="/profile"
                    className="dropdown-item"
                    onClick={() => setUserMenuOpen(false)}
                  >
                    <i className="bi bi-person-gear me-2" />
                    Meu cadastro
                  </Link>
                  <button
                    type="button"
                    className="dropdown-item"
                    onClick={handleLogout}
                  >
                    <i className="bi bi-box-arrow-right me-2" />
                    Sair
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
